import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=a4b5e6c4&"
import script from "./contextMenu.vue?vue&type=script&lang=js&"
export * from "./contextMenu.vue?vue&type=script&lang=js&"
import style0 from "./contextMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports